import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PNXLabel from "./PNXLabel";


interface ReadOnlyProps {
  controlProps: controls.ListFormControl;
}
interface Props extends ReadOnlyProps {
  updateValue: (newValue: string) => void;
  onControlBlur: () => void;
};

const PhoenixSelect = ({
  controlProps,
  updateValue,
  onControlBlur,
} : Props) => {

  // we have only ever used "full" appearance i.e. checkboxes
  const id = `select-${controlProps.id}`;

  // if its just a single dropdown, we need to render it differently because the SelectionControlGroup doesnt allow me to flex it :(
  if (controlProps.items?.length === 1 && controlProps.items[0].label === "") {
    return (
      <FormControlLabel
        className="pnx-select-single-option"
        control={
          <Checkbox
            checked={controlProps.value == controlProps.items[0].value}
            onChange={(e) => updateValue(e.target.checked ? controlProps.items[0].value : "")}
            onBlur={() => onControlBlur()}
          />
        }
        label={<PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>}
        labelPlacement="start"
      />
    );
  } else {
    const handleCheckboxChange = (itemValue: string, checked: boolean) => {
      const currentValues = controlProps.value ? controlProps.value.split(",").filter(v => v) : [];
      let newValues: string[];
      if (checked) {
        newValues = [...currentValues, itemValue];
      } else {
        newValues = currentValues.filter(v => v !== itemValue);
      }
      updateValue(newValues.join(","));
    };

    const selectedValues = controlProps.value ? controlProps.value.split(",") : [];

    return <div>
      <FormLabel component="legend"><PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel></FormLabel>
      <FormGroup>
        {controlProps.items.map((item, idx) => (
          <FormControlLabel
            key={idx}
            control={
              <Checkbox
                checked={selectedValues.includes(item.value)}
                onChange={(e) => handleCheckboxChange(item.value, e.target.checked)}
                onBlur={() => onControlBlur()}
              />
            }
            label={item.label}
          />
        ))}
      </FormGroup>
    </div>;
  }
};

export const willPhoenixSelectReadOnlyRender = (controlProps: controls.ListFormControl) => {
  if (!controlProps.value || !controlProps?.value?.split(",")?.length) return false;
  return true;
};

export const PhoenixSelectReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {

  if (!controlProps.value) return null;

  const selectedValues = controlProps.value.split(",");
  const selectedLabels = [];

  for (const value of selectedValues) {
    const option = controlProps.items.filter(item => item.value === value);
    if (option.length) {
      let label = option[0].label;
      if (!label && value === "1") // sweet
        label = "Yes";

      selectedLabels.push(label);
    }
    else {
      selectedLabels.push(value);
    }
  }

  if (!selectedLabels.length) return null;

  return (
    <div className={selectedLabels.length == 1 && "pnx-select-single-option"}>
      <PNXLabel>{controlProps.label}</PNXLabel>
      <div>
        {selectedLabels.map(label => <div>{label}</div>)}
      </div>
    </div>
  );
};

export default PhoenixSelect;